module.exports = __webpack_public_path__ + "components/flag/static/square/bl-5f2bb69ac523804027f7cc9caabe69fa.svg";